<template>
  <div>
    <div class="card shadow mb-3">
      <div class="card-header">
        Users
      </div>
      <div class="card-body" v-loading="loading">
        <user-chart />
      </div>
    </div>
    <div class="card shadow">
      <div class="card-header">
        Recent Users
      </div>
      <div v-loading="loading">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th>Name</th>
              <th>Email Address</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>
                <router-link :to="{ name: 'users-id', params: { id: user.id }}">
                  {{ user.name }}
                </router-link>
                <span class="badge badge-pill badge-light">{{ user.country_id }}</span>
                <div class="text-muted">@{{ user.username }}</div>
              </td>
              <td>{{ user.email }}</td>
              <td>{{ user.createdAt }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import UserChart from '@/components/User/UserChart'

export default {
  data() {
    return {
      loading: true,
      users: [],
    }
  },

  components: {
    UserChart,
  },

  mounted() {
    this.getUsers()
  },

  methods: {
    getPaidStatus(periodEnd) {
      return moment(periodEnd).isAfter(moment())
    },

    async getUsers() {
      try {
        var { data } = await this.$http.get(`/users`, {
          params: { offset: 0, limit: 25 },
        })
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.users = data.users.map(item => {
        item.createdAt = moment(item.createdAt).fromNow()
        return item
      })
    },
  },
}
</script>
